import React from "react";
import Joi from "joi-browser";
import {
  Container,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Form,
  Row,
} from "reactstrap";
import DefaultForm from "../common/defaultForm";
import { toast } from "react-toastify";
import Placeholder from "../common/placeholder";
import authService from "../services/authService";
import http from "../services/httpService";
import IMask from "imask";

const cpfMask = IMask.createMask({
  mask: "000.000.000-00",
  lazy: false,
  placeholderChar: "_",
});

class FormularioBolsista extends DefaultForm {
  schema = {
    name: Joi.string().required().max(256).label("Nome Completo"),
    cpf: Joi.string().required().min(11).max(11).label("CPF"),
    cpfMasked: Joi.any(),
    email: Joi.string().required().email().max(256).label("E-mail"),
    emailConfirmation: Joi.string().required().email().max(256).label("E-mail"),
    password: Joi.string().required().min(6).max(256).label("Senha"),
    passwordConfirmation: Joi.string()
      .required()
      .min(6)
      .max(256)
      .label("Confirmar Senha"),
  };

  state = {
    data: {
      name: "",
      cpf: "",
      cpfMasked: "",
      email: "",
      emailConfirmation: "",
      password: "",
      passwordConfirmation: "",
    },
    errors: {},
    submitting: false,
  };

  componentDidMount() {
    document
      .getElementById("emailConfirmation")
      .addEventListener("paste", (e) => e.preventDefault());
  }

  dataToDto() {
    const data = this.state.data;
    return {
      name: data.name,
      cpf: data.cpf,
      email: data.email,
      emailConfirmation: data.emailConfirmation,
      password: data.password,
      passwordConfirmation: data.passwordConfirmation,
    };
  }

  doSubmit = async () => {
    try {
      const data = this.dataToDto();
      const { data: res } = await authService.register(data);
      localStorage.setItem("token", res.token);
      http.setJwt(authService.getJwt());
      toast.success("Cadastro realizado com sucesso");
      this.props.history.push("/gerenciamento");
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ submitting: false });
  };

  compareEmail = () => {
    const { data, errors } = this.state;
    const { email, emailConfirmation } = data;

    if (email === emailConfirmation && errors.emailConfirmation) {
      delete errors.emailConfirmation;
      this.setState({ errors: { ...errors } });
    }
  };

  comparePassword = () => {
    const { data, errors } = this.state;
    const { password, passwordConfirmation } = data;

    if (password === passwordConfirmation && errors.passwordConfirmation) {
      delete errors.passwordConfirmation;
      this.setState({ errors: { ...errors } });
    }
  };

  onValidate(error = {}) {
    if (error) return error;

    const emailHasError = this.validateEmailConfirmation({
      error: null,
      value: this.state.data.emailConfirmation,
    });
    const passwordHasError = this.validatePasswordConfirmation({
      error: null,
      value: this.state.data.passwordConfirmation,
    });

    if (emailHasError) {
      return {
        details: [
          {
            path: "emailConfirmation",
            message: "Email deve ser igual ao preenchido acima",
          },
        ],
      };
    }

    if (passwordHasError) {
      return {
        details: [
          { path: "passwordConfirmation", message: "Senha não confere" },
        ],
      };
    }

    return null;
  }

  validateEmailConfirmation({ error, value }) {
    const isEqual = value === this.state.data["email"];

    if (!error && value && !isEqual) {
      return {
        details: [{ message: "Email deve ser igual ao preenchido acima" }],
      };
    }

    return error;
  }

  validatePasswordConfirmation({ error, value }) {
    const isEqual = value === this.state.data["password"];

    if (!error && value && !isEqual) {
      return {
        details: [{ message: "Senha não confere" }],
      };
    }

    return error;
  }

  onValidateProperty({ error, name, value }) {
    const isEmailConfirmation = name === "emailConfirmation";
    const isPasswordConfirmation = name === "passwordConfirmation";

    if (isEmailConfirmation) {
      return this.validateEmailConfirmation({ value, error });
    }

    if (isPasswordConfirmation) {
      return this.validatePasswordConfirmation({ value, error });
    }

    return error;
  }

  renderForm() {
    return (
      <Placeholder ready>
        <Form onSubmit={this.handleSubmit}>
          <Col md={{ size: "auto", offset: 1 }}>
            <CardTitle>
              <h4>Informações de cadastro</h4>
              <hr></hr>
            </CardTitle>
            <Row>
              <Col md="9">
                {this.renderInput(
                  "name",
                  "Nome Completo",
                  "text",
                  false,
                  false,
                  true,
                  true,
                  "Seu nome"
                )}
                {this.renderInput(
                  "email",//1
                  "E-mail",//2
                  "text",//3
                  false,//4
                  false,//5
                  false,//6
                  true,//7
                  "Seu e-mail",//8
                  null,//9
                  null,//10
                  false,//11
                  this.compareEmail//12
                )}
                {this.renderInput(
                  "emailConfirmation",//1
                  "Confirmar e-mail",//2
                  "text",//3
                  false,//4
                  false,//5
                  false,//6
                  true,//7
                  "Confirme seu e-mail",//8
                  null,//9
                  null,//10,
                  false,
                  this.compareEmail//11
                )}

                {this.renderInput(
                  "cpf",//1
                  "CPF",//2
                  "text",//3
                  false,//4
                  false,//5
                  true,//6
                  true,//7
                  "Seu cpf",//8
                 
                  cpfMask//9
                )}

                {this.renderInput(
                  "password",//1
                  "Senha",//2
                  "password",//3
                  false,//4
                  false,//5
                  true,////6
                  true,//7
                  "Cadastre uma senha",//8
                  null,//9
                  null,//10
                  false,
                  this.comparePassword//11
                )}
                <p style={{ fontSize: "12px", marginTop: "-12px" }}>
                  Sua senha precisa ter ao menos:
                </p>
                <ul
                  style={{
                    fontSize: "12px",
                    paddingLeft: "18px",
                    marginTop: "-10px",
                  }}
                >
                  <li>6 caracteres</li>
                  <li>Letras (maíuscula e minúscula), números e simbolos</li>
                </ul>

                {this.renderInput(
                  "passwordConfirmation",//1
                  "Confirmar Senha",//2
                  "password",//3
                  false,//4
                  false,//5
                  true,//6
                  true,//7
                  "Confirmar sua senha",//8
                  null,//9/
                  null,//10,
                  false,
                  this.comparePassword//11
                )}
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md={{ size: "5" }}>
                {this.renderButton(
                  "Cadastrar",
                  "btn btn-lg btn-success btn-block"
                )}
              </Col>
            </Row>
          </Col>
        </Form>
      </Placeholder>
    );
  }

  render() {
    return (
      <React.Fragment>
        <header className="background-home"></header>
        <div
          className="app flex-row align-items-center"
          style={{ marginTop: "32px" }}
        >
          <Container className="mt-2">
            <Row className="justify-content-center">
              <Col md="8">
                <Card color="success">
                  <CardHeader className="text-white text-center">
                    Formulário de Cadastro - Bolsista
                  </CardHeader>

                  <CardBody
                    style={{
                      backgroundColor: "white",
                      minHeight: "70vh",
                      maxHeight: "70vh",
                      overflow: "auto",
                    }}
                  >
                    {this.renderForm()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FormularioBolsista;
